export default "__VITE_PUBLIC_ASSET__7a4f30b8__"